import React, { useState } from 'react';
import PropTypes from 'prop-types';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import {getLabelShortName, uuidShortName} from '../../helpers';
import {Tooltip} from '@material-ui/core';

function VcamsFilter (props) {
  const { filterSelectedType = '', filterselectedItem = '', onAllSelected, onInfraNameSelected, onUuidSelected } = props;
  const [dOpen, setDOpen] = useState(false);
  const [infraOpen, setInfraOpen] = useState(false);

  function getFilterNames(item) {
    let {uuid, label} = item;
    let isNotEmptyLabel = label !== undefined && label !== null && label !== '';
    let tooltip = isNotEmptyLabel ? `${uuid} - ${label}` : uuid;
    let listItemName = isNotEmptyLabel ? `${uuidShortName(uuid)} - ${getLabelShortName(label)}` : uuidShortName(uuid);
    return {tooltip, listItemName};
  }

  function byDeviceList () {
    return (
      <Collapse in={dOpen} timeout='auto'>
        <List disablePadding>
          {
            props.uuidList.map(item => {
              const {tooltip, listItemName} = getFilterNames(item);
              return (
                <ListItem
                  button
                  key={item.label}
                  selected={filterSelectedType === 'By Device' && filterselectedItem === item.uuid}
                  onClick={() => onUuidSelected(item.uuid)}
                >
                  <Tooltip title={tooltip}>
                    <ListItemText>{listItemName}</ListItemText>
                  </Tooltip>
                </ListItem>
              );
            })
          }
        </List>
      </Collapse>
    );
  }

  function byInfraNameList () {
    return (
      <Collapse in={infraOpen} timeout='auto'>
        <List disablePadding>
          {
            props.infraNameList.map(({name, isPaired}) => (
              <ListItem
                button
                key={name}
                selected={filterSelectedType === 'By EWC' && filterselectedItem === name}
                onClick={() => onInfraNameSelected(name)}
                disabled={!isPaired}
              >
                <ListItemText primary={name} secondary={isPaired ? '' : 'Not Paired'} />
              </ListItem>
            ))
          }
        </List>
      </Collapse>
    );
  }

  return (
    <div>
      <div className="muted margin-bottom-small">Filter</div>
      <List>
        <ListItem disableGutters
          style={{ paddingLeft: 4 }}
          classes={{ root: 'grouplist' }}
          button
          key='All'
          selected={filterSelectedType === 'All'}
          onClick={() => onAllSelected('All')}
        >
          <ListItemText primary='All' />
        </ListItem>
        <ListItem disableGutters
          style={{ paddingLeft: 4 }}
          classes={{ root: 'grouplist' }}
          button
          key='By Device'
          onClick={() => setDOpen(open => !open)}
        >
          <ListItemText primary='By Device' />
          {dOpen ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
        {byDeviceList()}
        <ListItem disableGutters
          style={{ paddingLeft: 4 }}
          classes={{ root: 'grouplist' }}
          button
          key='By EWC'
          onClick={() => setInfraOpen(open => !open)}
        >
          <ListItemText primary='By EWC' />
          {infraOpen ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
        {byInfraNameList()}
      </List>
    </div>
  );
}

VcamsFilter.propTypes = {
  filterSelectedType: PropTypes.string.isRequired,
  filterselectedItem: PropTypes.string.isRequired,
  infraNameList: PropTypes.array.isRequired,
  uuidList: PropTypes.array.isRequired,
  onAllSelected: PropTypes.func.isRequired,
  onInfraNameSelected: PropTypes.func.isRequired,
  onUuidSelected: PropTypes.func.isRequired
};

export default React.memo(VcamsFilter);
